/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from '@access-erp/common';
import { CellType, FilterValueTypes } from '@access-erp/ui-components';
import { useMemo } from 'react';

import { filtersforBillingTypes } from '@/components/common/EnquiriesScreen/utils/filtersForStringigfiedNumbers';
import { renderBillingType }
  from '@/components/common/EnquiriesScreen/customFilters/BillingTypeMultiSelect';
import { guidFilterOptions } from '@/components/common/EnquiriesScreen/utils/filters.config';
import { filterMergeTypes } from '@/components/common/EnquiriesScreen/utils/statuses.config';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
}

export const useHeaderColumns = () => {
  const headerColumns: Column<any>[] = [
    {
      name: 'stockCode',
      caption: 'Stock Code',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 1,
    },
    {
      name: 'stockName',
      caption: 'Stock Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 2,
    },
    {
      name: 'productName',
      caption: 'Product Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 3,
    },
    {
      name: 'productFamily',
      caption: 'Product Family',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 4,
    },
    {
      name: 'productDivision',
      caption: 'Product Division',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 5,
    },
    {
      name: 'defaultBillingType',
      caption: 'Default Billing Type',
      width: 280,
      cellType: CellType.String,
      filterType: FilterValueTypes.StringMultiSelectFilter,
      renderFilter: (renderProps) => renderBillingType({ ...renderProps, title: 'Billing Type' }),
      filterOptions: {
        availableOptions: filtersforBillingTypes,
      },
      defaultFilter: 6,
    },
    {
      name: 'softwareCompany',
      caption: 'Software Company',
      width: 250,
      cellType: CellType.String,
      defaultFilter: 7,
    },
    {
      name: 'mergeType',
      caption: 'Merge Type',
      width: 200,
      cellType: CellType.String,
      filterType: FilterValueTypes.EnumFilter,
      filterData: filterMergeTypes,
      defaultFilter: 8,
    },
    {
      name: 'iD',
      caption: 'ID',
      width: 270,
      cellType: CellType.String,
      defaultFilter: 9,
      hidden: true,
      filterType: FilterValueTypes.StringFilter,
      filterOptions: {
        availableOptions: guidFilterOptions,
      }
    },
  ];

  return useMemo(() => ({ headerColumns }), []);
};
